import { render } from "./DangerButton.vue?vue&type=template&id=cdf2462e"
import script from "./DangerButton.vue?vue&type=script&lang=js"
export * from "./DangerButton.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "cdf2462e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('cdf2462e', script)) {
    api.reload('cdf2462e', script)
  }
  
  module.hot.accept("./DangerButton.vue?vue&type=template&id=cdf2462e", () => {
    api.rerender('cdf2462e', render)
  })

}

script.__file = "resources/js/Jetstream/DangerButton.vue"

export default script